// extracted by mini-css-extract-plugin
export default {"UploadCensus":"uploadCensus_UploadCensus__w56-H","UploadCensusTitle":"uploadCensus_UploadCensusTitle__+wd2B","UploadCensusFile":"uploadCensus_UploadCensusFile__cxdVD"};